export default "__VITE_ASSET__BWNjP7sl__"